import Axios from 'axios'

export default Axios.create({
  baseURL: 'https://pcm.sandi.net/apiserver/api.rsc/',
  headers: {'x-cdata-authtoken': '9b2P7g8r0Q1a1j8Y2g1u'}
});

export const cancelToken = Axios.CancelToken;


// WEBPACK FOOTER //
// ./src/utils/Ajax.js